import React from "react"
import styled from "styled-components"
import ReactMarkdown from "react-markdown"
import Carousel from "./carousel"
import Button from "./button"
import convertToKebabCase from "../helpers/convert-to-kebab-case"

const Container = styled.div`
    padding: 0.5rem 1rem;
    position: relative;
    @media screen and (min-width: 768px) {
        display: ${props => (props.visible ? "flex" : "none")};
        flex-direction: row-reverse;
        justify-content: space-between;
        padding-right: 0;
        h2 {
            color: ${props => props.theme.primary};
            margin-bottom: 0.75rem;
            position: relative;
            &:after {
                content: "";
                width: 90%;
                height: 1px;
                position: absolute;
                bottom: 0;
                left: 0;
                background: ${props => props.theme.lightGrey};
            }
        }
    }
`

const Column = styled.div`
    display: flex;
    flex-direction: column;
`

const CarouselWrapper = styled.div`
    @media screen and (min-width: 768px) {
        width: 50%;
        max-width: 500px;
    }
`

export default function Product({ data, images }) {
    return (
        <Container visible={true}>
            <CarouselWrapper id={convertToKebabCase(data.name)}>
                <Carousel images={images} data={data.images} />
            </CarouselWrapper>
            <div>
                <Column>
                    <h2>{data.name}</h2>
                    <p>{data.description}</p>
                    <ReactMarkdown
                        source={data.features}
                        className="bullet-list bullet-list-red"
                    />
                </Column>
                <Button
                    outbound
                    target="_blank"
                    to={`https://www.tuffshed.com/products/#/configurator/${encodeURIComponent(
                        data.name
                    )}`}
                >
                    Build-A-Quote
                </Button>
                <Button
                    text
                    target="_blank"
                    to={`https://www.tuffshed.com/products/#/details/${encodeURIComponent(
                        data.name
                    )}/size-pricing`}
                >
                    {data.linkText}
                </Button>
            </div>
        </Container>
    )
}
